import React, { useState, useEffect } from "react";
import "./passenger.css";
import { useNavigate } from "react-router-dom";
import BackMenu from "../../assets/icons/Arrow-Left-Back-Menu.png";
import DashboardPage from "../dashboard";

// Import calculateMenuOneEmissions
import { caldistance, cal_1 } from "../../utils/calculation";

import Decimal from "decimal.js";

const MenuOne = ({ data, caldistance }) => {
  // console.log('data', data);

  const navigate = useNavigate();

  const [originRouteKey, setOriginRouteKey] = useState("");
  const [destinationRouteKey, setDestinationRouteKey] = useState("");
  const [selectedOriginStationKey, setSelectedOriginStationKey] = useState("");
  const [selectedDestinationStationKey, setSelectedDestinationStationKey] =
    useState("");
  const [distanceKm, setDistanceKm] = useState(0);

  const [selectedTrainType, setSelectedTrainType] = useState("train");
  const [selectedRoadMode, setSelectedRoadMode] = useState(""); // Default เป็นค่าว่าง
  const roadModes = Object.values(data?.emission?.road_modes || {});
  const routesData = data?.transportation?.[selectedTrainType]?.routes || {};
  const routeKeys = Object.keys(routesData);

  const [emissionResults, setEmissionResults] = useState({
    road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
  });

  // Road
  const formatRoadTc02 = parseFloat(
    emissionResults.road.tCO2.toFixed(2)
  ).toLocaleString();
  const formatRoadKgPM2 = parseFloat(
    emissionResults.road.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatRoadKgNOx = parseFloat(
    emissionResults.road.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatRoadKgCO = parseFloat(
    emissionResults.road.kgCO.toFixed(2)
  ).toLocaleString();

  // Train
  const formatTrainTc02 = parseFloat(
    emissionResults.train.tCO2.toFixed(2)
  ).toLocaleString();
  const formatTrainKgPM2 = parseFloat(
    emissionResults.train.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatTrainKgNOx = parseFloat(
    emissionResults.train.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatTrainKgCO = parseFloat(
    emissionResults.train.kgCO.toFixed(2)
  ).toLocaleString();

  // Reduce
  const formatReduceTc02 = parseFloat(
    emissionResults.reduce.tCO2.toFixed(2)
  ).toLocaleString();
  const formatReduceKgPM2 = parseFloat(
    emissionResults.reduce.kgPM2.toFixed(2)
  ).toLocaleString();
  const formatReduceKgNOx = parseFloat(
    emissionResults.reduce.kgNOx.toFixed(2)
  ).toLocaleString();
  const formatReduceKgCO = parseFloat(
    emissionResults.reduce.kgCO.toFixed(2)
  ).toLocaleString();

  const getStations = (routeKey) => {
    return Object.entries(routesData?.[routeKey]?.stations || {});
  };

  //  useEffect สำหรับคำนวณระยะทาง
  useEffect(() => {
    if (
      selectedOriginStationKey &&
      selectedDestinationStationKey &&
      data?.transportation?.[selectedTrainType]?.routes &&
      caldistance
    ) {
      const dist = caldistance(
        data.transportation[selectedTrainType].routes,
        selectedOriginStationKey,
        selectedDestinationStationKey
      );
      setDistanceKm(dist || 0);
      console.log("Calculated distanceKm:", dist);
    } else {
      setDistanceKm(0);
    }
  }, [
    selectedOriginStationKey,
    selectedDestinationStationKey,
    selectedTrainType,
    data,
    caldistance,
  ]);

  // useEffect สำหรับคำนวณ Emission
  useEffect(() => {
    if (data && selectedRoadMode && distanceKm > 0) {
      console.log("Calcutate distanceKm = ");
      const calculatedEmissions = cal_1(
        data,
        selectedTrainType,
        selectedRoadMode,
        new Decimal(distanceKm)
      );
      setEmissionResults(calculatedEmissions);
      console.log("Updated Emission Results:", calculatedEmissions);
    } else {
      // รีเซ็ตค่าถ้าเงื่อนไขไม่ครบ
      setEmissionResults({
        road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
        train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
        reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
      });
    }
    //    console.log("--- End ช่วงตรวจสอบค่าการคำนวณ ---");
  }, [data, selectedRoadMode, selectedTrainType, distanceKm]);

  // Console logs สำหรับ fetch data (เก็บไว้ตามเดิม)
  useEffect(() => {
    if (data?.emission?.electrictrain) {
      // console.log("Emission by electrictrain :", data.emission.electrictrain);
    }
  }, [data]);

  useEffect(() => {
    if (data?.emission?.train) {
      // console.log("Emission by train :", data.emission.train);
    }
  }, [data]);

  useEffect(() => {
    if (data?.emission?.road_modes) {
      // console.log("Emission by road_modes :", data.emission.road_modes);
    }
  }, [data]);

  return (
    <div className="passenger-modal">
      {/* <div className="db"><DashboardPage /></div> */}
      <div className="passenger">
        <div className="all">
          <div className="box-name">
            <div className="t">เส้นทางและรูปแบบการเดินทาง</div>
          </div>

          {/**Green bg */}
          <div className="full-bg-green">
            <div className="green">
              <div className="block-input-remark">
                <div className="title-one">
                  <span
                    onClick={() => setSelectedTrainType("train")}
                    style={{
                      cursor: "pointer",
                      fontWeight:
                        selectedTrainType === "train" ? "bold" : "normal",
                      borderBottom:
                        selectedTrainType === "train"
                          ? "solid 2px goldenrod"
                          : "none",
                    }}
                  >
                    เดินทางด้วยรถไฟ
                  </span>
                  &nbsp; <span> {` / `} </span> &nbsp;
                  <span
                    onClick={() => setSelectedTrainType("electric-train")}
                    style={{
                      cursor: "pointer",
                      fontWeight:
                        selectedTrainType === "electric-train"
                          ? "bold"
                          : "normal",
                      borderBottom:
                        selectedTrainType === "electric-train"
                          ? "solid 2px goldenrod"
                          : "none",
                    }}
                  >
                    รถไฟฟ้า
                  </span>
                </div>

                {/**form 1   select 1 - 2*/}
                <div className="form-input-one">
                  <span className="span-form1-select1">
                    <div className="start">ต้นทาง</div>
                    <select
                      className="select-one"
                      value={originRouteKey}
                      onChange={(e) => {
                        setOriginRouteKey(e.target.value);
                        setSelectedOriginStationKey("");
                        setSelectedDestinationStationKey("");
                      }}
                    >
                      <option value="">{`เลือกสาย`}</option>{" "}
                      {/* เพิ่ม value="" */}
                      {routeKeys.map((key) => (
                        <option key={key} value={key}>
                          {routesData[key]["name-th"]}
                        </option>
                      ))}
                    </select>
                  </span>

                  <span className="span-form1-select1">
                    <div className="name-station">สถานี</div>
                    <select
                      className="select-name-station"
                      value={selectedOriginStationKey}
                      onChange={(e) =>
                        setSelectedOriginStationKey(e.target.value)
                      }
                      disabled={!originRouteKey}
                    >
                      <option value="">{`สถานี`}</option> {/* เพิ่ม value="" */}
                      {originRouteKey &&
                        getStations(originRouteKey).map(
                          ([stationKey, stationData]) => (
                            <option key={stationKey} value={stationKey}>
                              {stationData["name-th"]}
                            </option>
                          )
                        )}
                    </select>
                  </span>
                </div>

                {/**form 2   select 3 - 4*/}
                <div className="form-input-one">
                  <span className="span-form1-select1">
                    <div className="start">ปลายทาง</div>
                    <select
                      className="select-one"
                      value={destinationRouteKey}
                      onChange={(e) => {
                        setDestinationRouteKey(e.target.value);
                        setSelectedDestinationStationKey("");
                      }}
                    >
                      <option value="">{`เลือกสาย`}</option>{" "}
                      {/* เพิ่ม value="" */}
                      {routeKeys.map((key) => (
                        <option key={key} value={key}>
                          {routesData[key]["name-th"]}
                        </option>
                      ))}
                    </select>
                  </span>

                  <span className="span-form1-select1">
                    <div className="name-station">สถานี</div>
                    <select
                      className="select-name-station"
                      value={selectedDestinationStationKey}
                      onChange={(e) =>
                        setSelectedDestinationStationKey(e.target.value)
                      }
                      disabled={!destinationRouteKey}
                    >
                      <option value="">{`สถานี`}</option> {/* เพิ่ม value="" */}
                      {destinationRouteKey &&
                        getStations(destinationRouteKey).map(
                          ([stationKey, stationData]) => (
                            <option key={stationKey} value={stationKey}>
                              {stationData["name-th"]}
                            </option>
                          )
                        )}
                    </select>
                  </span>
                </div>

                <div className="form-input-one">
                  <span className="span-form1-select1">
                    <div className="start"></div>
                    <div className="select-one">
                      <div className="alert">
                        {originRouteKey &&
                        destinationRouteKey &&
                        originRouteKey !== destinationRouteKey
                          ? selectedTrainType === "electric-train"
                            ? `ระยะทาง: ${distanceKm.toFixed(2)} km.`
                            : "ไม่สามารถคำนวณข้ามสายได้"
                          : distanceKm > 0
                          ? `ระยะทาง: ${distanceKm.toFixed(2)} km.`
                          : "กรุณาเลือกสถานีต้นทางและปลายทาง"}
                      </div>
                    </div>
                  </span>
                  {/* <div className="">
                  {originRouteKey &&
                  destinationRouteKey &&
                  originRouteKey !== destinationRouteKey
                    ? selectedTrainType === "electric-train"
                      ? `ระยะทาง: ${distanceKm.toFixed(2)} km.`
                      : "ไม่สามารถคำนวณข้ามสายได้"
                    : distanceKm > 0
                    ? `ระยะทาง: ${distanceKm.toFixed(2)} km.`
                    : "กรุณาเลือกสถานีต้นทางและปลายทาง"}
                </div> */}
                </div>

                {/**form 3  select 5*/}
                <div className="form-input-one">
                  <span className="span-form1-select1">
                    <div className="start-2">
                      เปรียบเทียบกับการเดินทางรูปแบบ
                    </div>
                    {/* <select
                    className="select-one"
                    value={destinationRouteKey}
                    onChange={(e) => {
                      setDestinationRouteKey(e.target.value);
                      setSelectedDestinationStationKey("");
                    }}
                  >
                    <option value="">{`เลือกสาย`}</option>{" "}
                   
                    {routeKeys.map((key) => (
                      <option key={key} value={key}>
                        {routesData[key]["name-th"]}
                      </option>
                    ))}
                  </select> */}
                  </span>

                  <span className="span-form1-select1">
                    <div className="name-station"></div>
                    <select
                      className="select-name-station2"
                      value={selectedRoadMode}
                      onChange={(e) => setSelectedRoadMode(e.target.value)}
                    >
                      <option value="">{`ประเภทรถ`}</option>
                      {roadModes.map((roadMode, index) => (
                        <option key={index} value={roadMode["name-en"]}>
                          {roadMode["name-th"]}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>

                {/**form 3 select 5 */}
                {/* <div className="form-input-one-2">
                <div className="start-2">เปรียบเทียบกับการเดินทางรูปแบบ</div>
                <select
                  className="select-name-station2"
                  value={selectedRoadMode}
                  onChange={(e) => setSelectedRoadMode(e.target.value)}
                >
                  <option value="">{`ประเภทรถ`}</option>
                  {roadModes.map((roadMode, index) => (
                    <option key={index} value={roadMode["name-en"]}>
                      {roadMode["name-th"]}
                    </option>
                  ))}
                </select>
              </div> */}

                <div className="remark-b1">
                  หมายเหตุ: *กำหนดให้เชื้อเพลิงที่ใช้เป็นดีเซล
                </div>
              </div>
            </div>
          </div>

          <>
                 {/**Green bg */}

          {/**layer 2  */}
          {/* <div className="green">
            <div className="box-name">
              <div className="t">ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง</div>
            </div>

            
              <div className="table-group">
              <div className="name-table">กรณีขนส่งทางถนน</div>
             
              <table id="passenger">
                <thead>
                  <tr>
                    <th>
                      CO<sub>2</sub>
                    </th>
                    <th>
                      PM<sub>2.5</sub>
                    </th>
                    <th>
                      NO<sub>x</sub>
                    </th>
                    <th>CO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: "#000" }}>{formatRoadTc02}</td>
                    <td style={{ color: "#000" }}>{formatRoadKgPM2}</td>
                    <td style={{ color: "#000" }}>{formatRoadKgNOx}</td>
                    <td style={{ color: "#000" }}>{formatRoadKgCO}</td>
                  </tr>
                </tbody>
              </table>

             
              <div className="name-table">กรณีขนส่งทางราง</div>

              <table id="passenger">
                <thead>
                  <tr>
                    <th>
                      CO<sub>2</sub>
                    </th>
                    <th>
                      PM<sub>2.5</sub>
                    </th>
                    <th>
                      NO<sub>x</sub>
                    </th>
                    <th>CO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: "#000" }}>{formatTrainTc02}</td>
                    <td style={{ color: "#000" }}>{formatTrainKgPM2}</td>
                    <td style={{ color: "#000" }}>{formatTrainKgNOx}</td>
                    <td style={{ color: "#000" }}>{formatTrainKgCO}</td>
                  </tr>
                </tbody>
              </table>

              
              <div className="name-table">
                ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
              </div>

              <table id="passenger">
                <thead>
                  <tr>
                    <th>
                      CO<sub>2</sub>
                    </th>
                    <th>
                      PM<sub>2.5</sub>
                    </th>
                    <th>
                      NO<sub>x</sub>
                    </th>
                    <th>CO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: "#000" }}>{formatReduceTc02}</td>
                    <td style={{ color: "#000" }}>{formatReduceKgPM2}</td>
                    <td style={{ color: "#000" }}>{formatReduceKgNOx}</td>
                    <td style={{ color: "#000" }}>{formatReduceKgCO}</td>
                  </tr>
                </tbody>
              </table>

              <div className="remark-12">
                <div>
                  หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                  <span style={{ color: "#2ecc71" }}>
                    {` `}
                    {` `} g
                  </span>
                </div>
                <div>
                  หน่วย PM<sub>2.5</sub> No<sub>x</sub>CO {` `} คือ
                  <span style={{ color: "#2ecc71" }}> {` `}mg</span>
                </div>
              </div>
            </div>
        
          </div> */}

          {/* <div className="green">
            <div className="box-name">
              <div className="t">ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง</div>
            </div>

            <div className="table-group">
              <div className="new-row-output">
                <div className="name-table"></div>

                <div className="is-table">
                  <div className="thaed">CO</div>
                  <div className="thaed">
                    PM<sub>2</sub>
                  </div>
                  <div className="thaed">
                    NO<sub>x</sub>
                  </div>
                  <div className="thaed">
                    CO<sub>2</sub>
                  </div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">กรณีขนส่งทางถนน</div>

                <div className="is-table">
                  <div className="tbody">{formatRoadTc02}</div>
                  <div className="tbody">{formatRoadKgPM2}</div>
                  <div className="tbody">{formatRoadKgNOx}</div>
                  <div className="tbody">{formatRoadKgCO}</div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">กรณีขนส่งทางราง</div>

                <div className="is-table">
                  <div className="tbody">{formatTrainTc02}</div>
                  <div className="tbody">{formatTrainKgPM2}</div>
                  <div className="tbody">{formatTrainKgNOx}</div>
                  <div className="tbody">{formatTrainKgCO}</div>
                </div>
              </div>

              <div className="new-row-output">
                <div className="name-table">
                  ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
                </div>

                <div className="is-table">
                  <div className="tbody">{formatReduceTc02}</div>
                  <div className="tbody">{formatReduceKgPM2}</div>
                  <div className="tbody">{formatReduceKgNOx}</div>
                  <div className="tbody">{formatReduceKgCO}</div>
                </div>
              </div>

              <div className="remark-12">
                <div>
                  หมายเหตุ: หน่วย CO<sub>2</sub> คือ
                  <span style={{ color: "#2ecc71" }}>
                    {` `}
                    {` `} g
                  </span>
                </div>
                <div>
                  หน่วย PM<sub>2.5</sub> No<sub>x</sub>CO {` `} คือ
                  <span style={{ color: "#2ecc71" }}> {` `}mg</span>
                </div>
              </div>
            </div>
          </div> */}          
          </>

          <div className="output-layout">
            ก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลง
          </div>

          <div className="hihi">
            <div className="show-output">
              <div className="output-text"></div>
              <div className="output-number">
                <div className="b-head">
                  CO<sub>2</sub>
                </div>
                <div className="b-head">
                  PM<sub>2.5</sub>
                </div>
                <div className="b-head">
                  NO<sub>x</sub>
                </div>
                <div className="b-head">
                  CO<sub></sub>
                </div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">กรณีขนส่งทางถนน</div>
              <div className="output-number">
                <div className="b-num">{formatRoadTc02}</div>
                <div className="b-num">{formatRoadKgPM2}</div>
                <div className="b-num">{formatRoadKgNOx}</div>
                <div className="b-num">{formatRoadKgCO}</div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">กรณีขนส่งทางราง</div>
              <div className="output-number">
                <div className="b-num">{formatTrainTc02}</div>
                <div className="b-num">{formatTrainKgPM2}</div>
                <div className="b-num">{formatTrainKgNOx}</div>
                <div className="b-num">{formatTrainKgCO}</div>
              </div>
            </div>
            <div className="show-output">
              <div className="output-text">
                ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
              </div>
              <div className="output-number">
                <div className="b-num">{formatReduceTc02}</div>
                <div className="b-num">{formatReduceKgPM2}</div>
                <div className="b-num">{formatReduceKgNOx}</div>
                <div className="b-num">{formatReduceKgCO}</div>
              </div>
            </div>

            {/*           
            <div className="output-groups">
            <div className="l-menu"></div>
            <div className="r-menu">
              <div>
                CO<sub>2</sub>
              </div>
              <div>
                PM<sub>2</sub>
              </div>
              <div>
                {" "}
                NO<sub>x</sub>
              </div>
              <div>CO</div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu">กรณีขนส่งทางถนน</div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatRoadTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgPM2}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatRoadKgCO}</div>
              </div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu"> กรณีขนส่งทางราง</div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatTrainTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatTrainKgPM2}</div>
              </div>

              <div className="box-num1">
                <div className="tbody1">{formatTrainKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatTrainKgCO}</div>
              </div>
            </div>
          </div> */}

            {/* <div className="output-groups">
            <div className="l-menu">
              ปริมาณก๊าซเรือนกระจกและมลภาวะทางอากาศที่ลดลงเมื่อขนส่งสินค้าทางราง
            </div>
            <div className="r-menu">
              <div className="box-num1">
                <div className="tbody1">{formatReduceTc02}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgPM2}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgNOx}</div>
              </div>
              <div className="box-num1">
                <div className="tbody1">{formatReduceKgCO}</div>
              </div>
            </div>
          </div> */}

          <div className="show-output-remark">
            <div className="output-text-remark">
            <div className="remark-output">
            <div>
              หมายเหตุ: หน่วย CO<sub>2</sub> คือ
              <span style={{ color: "#2ecc71" }}>
                {` `}
                {` `} g
              </span>
            </div>
            <div >
              หน่วย {` `}{" "}
              <span>
                PM<sub>2.5</sub>
              </span>{" "}
              {` `}
              <span>
                NO<sub>x</sub>
              </span>
              {` `}CO {` `} คือ
              <span style={{ color: "#2ecc71" }}> {` `}mg</span>
            </div>
          </div>
          </div>
          </div>

          </div>

          
        </div>
        {/**All */}
      </div>
    </div>
  );
};

export default MenuOne;
